var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"focus"},[_c('img',{class:'focus' + _vm.current,attrs:{"src":require("../assets/image/other/focus.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }